exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tableFilter>thead>tr{\r\n  background: #1C869A;\r\n  color: white;\n}\r\n", ""]);

// exports
